<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button v-if="!validando"
      :variant="
          data.item.estatusReplicaCdx == 'Sin réplica' 
          ? 'outline-warning'
          : 'outline-success'
      "
      @click="
        deleteFinalizarSolicitud(
          data.item.idSolicitudBandejaEspecialista,
          data.item.replica,
           data.item.estatusReplicaCdx,
           data.item.idSolicitudEtapa
        )
      "
    :disabled="data.item.estatusReplicaCdx !== 'Sin réplica'
    && data.item.estatusReplicaCdx === 'Proceso' "
      >Validar</b-button
    >
    <b-button v-else disabled variant="success">
      <b-spinner small></b-spinner>
      Validando...
    </b-button>
  </div>
</template>

<script>
export default {
  name: "FinalizarSolicitudComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    listaBandejaEspecialistas: [],
    validando: false,
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    deleteFinalizarSolicitud(idSolicitudBandejaEspecialista, replica, estatusReplicaCdx, idSolicitudEtapa ) {
 


        var title ="¿Estás seguro de finalizar la solicitud?";
        
        if(estatusReplicaCdx == 'Sin réplica'){
          title = "¿Estás seguro de finalizar la solicitud sin realizar réplica?";
        } else if (estatusReplicaCdx == 'Finalizado'){ 
          title = "¿Desea finalizar la solicitud?";
        }

        this.$swal.fire({
          title: title,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.validando = true;
            this.$http
              .post(
                this.$api +
                  "bandejaespecialista/finalizarsolicitud/" +
                  idSolicitudBandejaEspecialista +
                  "?idUsuario=" +
                  this.$localStorageService.getIdUsuario() +
                  "&idSolicitudEtapa=" + idSolicitudEtapa
              )
              .then((response) => {
                if (response.status === 200) {
                  this.$swal({
                    icon: "success",
                    title: "Se finalizó correctamente",
                    showConfirmButton: false,
                    timer: 2500,
                  });
                }
              })
              .catch((error) => {
                console.error("errror" + error);
                this.$swal({
                  icon: "error",
                  title: "Ocurrio un error al procesar la solicitud",
                  showConfirmButton: false,
                  timer: 2500,
                });
              })
              .finally(() => {
                this.funcionExtraBandeja({id:2});
                this.validando = false;
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      
    },
    funcionExtraBandeja(data) {
      this.$emit("_funcionExtra", data,0);
    },
  },
  mounted() {},
};
</script>
